import script from "./PatientInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientInformation.vue?vue&type=script&setup=true&lang=js"

import "./PatientInformation.vue?vue&type=style&index=0&id=e60750ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e60750ba"]])

export default __exports__